// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import {FEATURE_LIBRARY_BASE_URL} from 'molbio/feature-libraries/FeatureLibraryConstants';
import {
  SelectableAttributes,
  Model as SelectableModel,
  Collection as SelectableCollection,
} from 'molbio/maps/selectables/Selectables';

export interface FeatureAttributes extends SelectableAttributes {
  name: string;
  bases: string;
  color: string;
  library_id: number;
  feature_type: string;
  match_type: 'protein' | 'nucleotide';
  id?: number;
}

interface Feature {
  get<K extends keyof FeatureAttributes>(key: K): FeatureAttributes[K];
  set(obj: Partial<FeatureAttributes>, options?: {silent?: boolean}): Feature;
  set<K extends keyof FeatureAttributes>(key: K, value: FeatureAttributes[K]): Feature;
}

// @ts-expect-error: we skip implementing several abstract methods. Really we should separate out a "Selectable"
// model from a "SelectableFeature" model which could additionally expect `start`, `end` and `strand` methods
class Feature extends SelectableModel {
  // We expect that Feature is always instantiated with non-null name, bases, etc attributes, so these
  // defaults do not actually conform to expectations
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
  override defaults() {
    return {
      ...super.defaults(),
      name: null,
      bases: null,
      color: 'black',
      library_id: null,
      feature_type: null,
      match_type: null,
    };
  }

  name(): string {
    return this.get('name');
  }
  color(): string {
    return this.get('color');
  }

  // NOTE: really this method is the "pattern" concept, which may actually be AA residues or contain
  // regex-style characters
  bases(): string {
    return this.get('bases');
  }

  // 🤦 why is this camelCase but the default uses "feature_type" as the key?
  featureType(): string {
    // @ts-expect-error
    return this.get('featureType');
  }
  matchType(): 'nucleotide' | 'protein' {
    return this.get('match_type');
  }

  bulkUrl(): string {
    return `${FEATURE_LIBRARY_BASE_URL}${this.get('library_id')}/features/`;
  }

  // @ts-expect-error - Backbone types declare `url` as a property, but it actually works with methods too
  url(): string {
    const base = this.bulkUrl();
    if (this.get('id') != null) {
      return base + this.get('id');
    } else {
      return base;
    }
  }

  override validate(attrs: FeatureAttributes, options?: unknown): string | undefined {
    if (!attrs.name) {
      return 'A feature must have a valid name.';
    } else if (!attrs.bases) {
      return 'A feature must specify bases.';
    }
    return undefined;
  }
}

export interface FeatureLibraryAttributes {
  writable: boolean;
  admin: boolean;
  owner: boolean;
  features: SelectableCollection<Feature>;
  api_identifier: string;
  name: string;
}

export class FeatureLibrary extends Backbone.Model {
  // @ts-expect-error - Backbone types declare `url` as a property, but it actually works with methods too
  url(): string {
    if (this.get('id') != null) {
      return FEATURE_LIBRARY_BASE_URL + this.get('id');
    } else {
      return FEATURE_LIBRARY_BASE_URL;
    }
  }

  override defaults(): Partial<FeatureLibraryAttributes> {
    return {
      writable: true,
      admin: true,
      owner: true,
      // @ts-expect-error
      features: new SelectableCollection<Feature>({model: Feature}),
    };
  }

  override initialize(): void {
    this.set('features', new SelectableCollection(this.get('features'), {model: Feature}));
  }

  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  override parse(response: any): any {
    response.features = new SelectableCollection(response.features, {model: Feature});
    return response;
  }
}

export class FeatureLibraries extends Backbone.Collection<FeatureLibrary> {
  static initClass(): void {
    this.prototype.model = FeatureLibrary;
    this.prototype.url = FEATURE_LIBRARY_BASE_URL;
  }
}
FeatureLibraries.initClass();

export {Feature, FeatureLibrary as Model, FeatureLibraries as Collection};
